import React, { useState } from "react";
import { Card, Upload, Button, message } from "antd";
import { InboxOutlined, DownloadOutlined } from "@ant-design/icons";
import apiClient from "../utils/apiClient";

const { Dragger } = Upload;

const TransportImport = () => {
  const [uploading, setUploading] = useState(false);

  // ✅ NEW CORRECT API

const API_URL = "/transport/import-csv";

  const handleImport = async (file) => {
    const formData = new FormData();
    formData.append("file", file);

    try {
      setUploading(true);

      await apiClient.post(API_URL, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      message.success("CSV uploaded successfully");
    } catch (error) {
      console.error(error);
      message.error("Upload failed");
    } finally {
      setUploading(false);
    }
  };

  const uploadProps = {
    name: "file",
    multiple: false,
    accept: ".csv", // ✅ only CSV
    beforeUpload: (file) => {
      handleImport(file);
      return false;
    },
    showUploadList: false,
  };

  // ✅ NEW CLEAN TEMPLATE (route आधारित)
  const downloadTemplate = () => {
    const csvContent = `routeName,from,to,vehicleType,distance,duration,cost,notes
Delhi to Narkanda,Delhi,Narkanda,Tempo Traveller,450,10h,12000,Mountain route
Narkanda to Spiti,Narkanda,Spiti,Tempo Traveller,300,8h,9000,High altitude
Spiti to Manali,Spiti,Manali,Tempo Traveller,200,7h,8000,Rough terrain
Manali to Delhi,Manali,Delhi,Tempo Traveller,550,12h,14000,Return journey`;

    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "transport_sample.csv";
    a.click();

    window.URL.revokeObjectURL(url);
  };

  return (
    <div style={{ maxWidth: 600, margin: "40px auto" }}>
      <Card title="Upload Transport CSV">

        <Dragger {...uploadProps} disabled={uploading}>
          <p className="ant-upload-drag-icon">
            <InboxOutlined style={{ fontSize: 40 }} />
          </p>
          <p>Click or drag CSV file to upload</p>
        </Dragger>

        <Button
          type="primary"
          icon={<DownloadOutlined />}
          onClick={downloadTemplate}
          style={{ marginTop: 20 }}
          block
        >
          Download Sample CSV
        </Button>

      </Card>
    </div>
  );
};

export default TransportImport;
